import i18next from 'i18next'
import { platform } from 'utils'
import Model from './Model'

export default class Account extends Model {

	/** @type number */ id
	/** @type string */ id_string
	/** @type string */ display_name
	/** @type string */ location_wording_singular
	/** @type string */ location_wording_plural
	/** @type ?bool */ display_zero_dollar_items
	/** @type ?bool */ shipday_globally_disabled
	/**
	 * Nullable while there are old logins without it. USE ONLY WHEN NECESSARY. Prefer using {@link app_url}
	 * @type {{android: string, apple: int}|null}
	 */ app_ids
	/**
	 * Contains the complete URLs for the different logo sizes
	 * @type {{'1x': string, '2x': string}}
	 */ logo
	/**
	 * The URL for the native app of the current operating system, if any.
	 * @type ?string
	 */ app_url = null
	/**
	 * Details on the allowed chat platform, if any.
	 * @type {undefined | { platform: 1|2|3, key: string, signature: ?string }}
	 */ chat
	/** @type number */ shipday_enabled_status
	/** @type bool */ deliver_by_ourselves_enabled
	/** This is only a toggle for the account. The user also needs to have the edit permission, and the order must be in the correct time window.
	 * @see User.useCanAdjustOrders()
	 * @type bool */ adjustments_disabled

	constructor(attr) {
		super(attr)

		this.display_zero_dollar_items = typeof this.display_zero_dollar_items === 'undefined'? null : !!this.display_zero_dollar_items

		//these will either be location/locations, which we _can_ translate, or random words
		//region location word translations
		// t('location')
		// t('locations')
		// t('menu', { context: 'custom location word' })
		// t('menus', { context: 'custom location word' })
		// t('special menu', { context: 'custom location word' })
		// t('special menus', { context: 'custom location word' })
		// t('restaurant', { context: 'custom location word' })
		// t('restaurants', { context: 'custom location word' })
		// t('food truck', { context: 'custom location word' })
		// t('food trucks', { context: 'custom location word' })
		// t('pizzeria', { context: 'custom location word' })
		// t('pizzerias', { context: 'custom location word' })
		// t('order option', { context: 'custom location word' })
		// t('order options', { context: 'custom location word' })
		// t('ghost kitchen', { context: 'custom location word' })
		// t('ghost kitchens', { context: 'custom location word' })
		// t('pick up location', { context: 'custom location word' })
		// t('pick up locations', { context: 'custom location word' })
		// t('pickup location', { context: 'custom location word' })
		// t('pickup locations', { context: 'custom location word' })
		// t('pick-up location', { context: 'custom location word' })
		// t('pick-up locations', { context: 'custom location word' })
		//endregion
		const context = 'custom location word'
		this.location_wording_singular = i18next.t((this.location_wording_singular || 'location').toLowerCase(), { context })
		this.location_wording_plural   = i18next.t((this.location_wording_plural || 'locations').toLowerCase(), { context })

		//region app_urls
		if (platform.isComputer() || this.app_ids == undefined) {
			this.app_url = null
		} else if (platform.isIOS()) {
			const country = i18next.t('us')
			this.app_url  = this.app_ids.apple? `https://itunes.apple.com/${country}/app/id${this.app_ids.apple}` : null
		} else if (platform.isAndroid()) {
			const lang   = i18next.t('en_US')
			this.app_url = this.app_ids.android? `https://play.google.com/store/apps/details?hl=${lang}&id=${this.app_ids.android}` : null
		}
		//endregion
	}

	strLocation(count, total = null) {
		let str
		if (total !== null && count == total) {
			str = i18next.t('all the {{LOCATIONS}}', { LOCATIONS: this.location_wording_plural })
		} else {
			str = (count == 1)?
				i18next.t('one {{LOCATION}}', { LOCATION: this.location_wording_singular }) :
				i18next.t('{{count}} {{LOCATIONS}}', { count, LOCATIONS: this.location_wording_plural })
		}

		return str.replaceAll(' ', '\u00A0') //NBSP
	}

	/**
	 * Either if Shipday is enabled or haven't been fully disabled yet.
	 * @param CONSTANTS {SERVER_CONSTANTS} Damn hooks... Whatever you get from {@link useServerConstants}.VALUES
	 * @returns {boolean}
	 */
	isShipdayOn(CONSTANTS) {
		return [
			CONSTANTS.ACCOUNT.SHIPDAY_STATUS.ENABLED,
			CONSTANTS.ACCOUNT.SHIPDAY_STATUS.DISABLE_REQUESTED,
		].includes(this.shipday_enabled_status)
	}

	/**
	 * Either if Shipday was requested to be enabled or disabled.
	 * @param CONSTANTS {SERVER_CONSTANTS} Damn hooks... Whatever you get from {@link useServerConstants}
	 * @returns {boolean}
	 */
	isShipdayRequestPending(CONSTANTS) {
		return [
			CONSTANTS.ACCOUNT.SHIPDAY_STATUS.REQUESTED,
			CONSTANTS.ACCOUNT.SHIPDAY_STATUS.DISABLE_REQUESTED,
		].includes(this.shipday_enabled_status)
	}
}
